<template>
  <div
    :class="[
      'content d-flex items-center',
      { 'is-vertical': VERTICAL_TEMPLATES[content.templateId] },
    ]"
  >
    <button
      class="move-detail-button-area d-flex justify-between items-center"
      @click="
        $router.push({
          name: 'ja-content-detail',
          params: { contentId: content.contentId },
        })
      "
    >
      <ja-content-preview
        class="content-preview"
        :processNum="CREATE_CONTENT_PROCESS_NUM.CONTENT_LIST_PREVIEW"
        :templateId="content.templateId"
        :contentMaterialList="content.contentMaterialList"
        :contentCaption="content.contentCaption"
        :contentCaptionColor="content.contentCaptionColor"
        :contentFrame="content.contentFrameDto"
      />

      <div class="content-text">
        <div class="content-detail d-flex items-center justify-between">
          <div class="content-create-date">
            {{ content.contentCreateDate }}
          </div>
          <div v-if="contentDuration" class="content-duration d-flex items-center">
            <img :src="VIDEO_ICON" alt="video icon" />
            <span class="duration">
              {{ convertSecTommss(contentDuration) }}
            </span>
          </div>
        </div>
      </div>
      <trash-button :onClickFunc="clickDeleteDialog" />
    </button>
  </div>
</template>

<script setup>
import TrashButton from '@/components/common/TrashButton.vue';
import { onMounted, ref } from 'vue';
import { isImageFile, convertSecTommss } from '@/composable/material_common';
import axios from '@/composable/axios';
import { useStore } from 'vuex';
import { handleAxiosCommonException } from '@/composable/common';
import { onsConfirm } from '@/composable/onsen_common';
import { useI18n } from 'vue-i18n';
import {
  VERTICAL_TEMPLATES,
  CREATE_CONTENT_PROCESS_NUM,
  VIDEO_ICON,
} from '@/composable/constant_common';
import JaContentPreview from './JaContentPreview.vue';

const { t } = useI18n();

const store = useStore();

const props = defineProps({
  content: {
    type: Object,
  },
  getContents: {
    type: Function,
  },
});

const contentDuration = ref(null);

const contentDelete = () => {
  // 素材削除処理を実行
  const DeleteContentParameters = new URLSearchParams();
  DeleteContentParameters.append('contentId', props.content.contentId);
  DeleteContentParameters.append('userId', store.getters['userInformation/getUserId']);
  axios
    .delete('/content', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      data: DeleteContentParameters,
    })
    .then(() => {
      props.getContents();
    })
    .catch((error) => {
      // Axios共通エラーハンドリング処理をCall
      handleAxiosCommonException(error);
    });
};

const clickDeleteDialog = (e) => {
  e?.stopPropagation();
  onsConfirm(t('message.SIGNAGE003I'))
    .then(() => {
      contentDelete();
    })
    .catch(() => {});
};

onMounted(() => {
  props.content.contentMaterialList.forEach((contentMaterial) => {
    if (!isImageFile(contentMaterial.materialUrl)) {
      contentDuration.value = contentMaterial.materialDuration;
    }
  });
});
</script>
<style scoped>
.content {
  width: 100%;
  height: 10rem;
  border-bottom: 0.1rem solid #ddd;
}
.content:first-child {
  border-top: 0.1rem solid #ddd;
}

.move-detail-button-area {
  background-color: white;
  border: none;
  width: 100%;
  height: 100%;
  padding: 0;
}
.content-text {
  flex-grow: 1;
}
.is-vertical .content-text {
  width: 75%;
}
.content-preview {
  flex-shrink: 0;
  height: 10rem;
  width: calc(10rem * (16 / 9));
  text-align: left;
}
.is-vertical .content-preview {
  height: 10rem;
  width: calc(10rem * (9 / 16));
  padding-left: 2rem;
  padding-right: 2rem;
}
.content-detail {
  width: 100%;
  font-size: 1.4rem;
  color: #aaa;
  text-align: left;
}
.content-create-date {
  font-size: 1.6rem;
  color: #222222;
  padding-left: 1rem;
}
.duration {
  padding-left: 0.5rem;
}
.move-button-area {
  width: 15%;
  height: 100%;
}
.play-icon {
  background-color: #fff;
  color: #aaa;
  font-size: 3vmin;
}
</style>
